<template>
  <div id="wrap">
    <div class="dashboard clear">
      <Toolbar :menuInfo="menuInfo"></Toolbar>
      <div class="right">
        <Navigation :menuInfo="menuInfo"></Navigation>
        <div class="main">
          <div class="main-nav">
            <ContentsNavigation v-if="false && (menuInfo.company || menuInfo.device)" :menuInfo="menuInfo" @selectNode="selectNode"></ContentsNavigation>
          </div>
          <div class="board clear">
            <TreeView
              :treeType="treeType"
              :treeScope="treeScope"
              :refreshEvent="refreshEvent"
              @selectNode="selectNode"
            ></TreeView>
            <div
              v-if="viewType === 'companyList' || viewType === 'divisionList' || viewType === 'userList'"
              class="list"
            >
              <CompanyList
                v-if="viewType === 'companyList'"
                :searchCondition="searchCondition"
                :startTime="startTime"
                :endTime="endTime"
                :searchEvent="selectEvent"
                @companyDetail="companyDetail"
                @companyCreate="companyCreate"
              ></CompanyList>
              <DivisionList
                v-else-if="viewType === 'divisionList'"
                :companyID="company.id"
                :companyName="company.name"
                :companyAlias="company.alias"
                :registrationNo="company.registrationNo"
                :scope="company.scope"
                :searchCondition="searchCondition"
                :startTime="startTime"
                :endTime="endTime"
                :searchEvent="selectEvent"
                @divisionDetail="divisionDetail"
                @divisionCreate="divisionCreate"
              ></DivisionList>
              <UserList
                v-else-if="viewType === 'userList'"
                :companyID="division.pID"
                :companyName="division.pName"
                :companyAlias="division.pAlias"
                :divisionID="division.id"
                :divisionName="division.name"
                :divisionAlias="division.alias"
                :searchCondition="searchCondition"
                :startTime="startTime"
                :endTime="endTime"
                :searchEvent="selectEvent"
                @userDetail="userDetail"
                @userCreate="userCreate"
              ></UserList>
            </div>
            <div
              v-else-if="viewType === 'companyDetail' || viewType === 'divisionDetail' || viewType === 'userDetail'"
              class="detail"
            >
              <CompanyDetail
                v-if="viewType === 'companyDetail'"
                :company="company"
                @refreshList="selectNode"
              ></CompanyDetail>
              <DivisionDetail
                v-else-if="viewType === 'divisionDetail'"
                :division="division"
                @refreshList="selectNode"
              ></DivisionDetail>
              <UserDetail
                v-else-if="viewType === 'userDetail'"
                :division="division"
                :user="user"
                @refreshList="selectNode"
              ></UserDetail>
            </div>
            <div
              v-else-if="viewType === 'companyCreate' || viewType === 'divisionCreate' || viewType === 'userCreate'"
              class="create"
            >
              <CompanyCreate
                v-if="viewType === 'companyCreate'"
                @refreshList="selectNode"
              ></CompanyCreate>
              <DivisionCreate
                v-else-if="viewType === 'divisionCreate'"
                :company="company"
                @refreshList="selectNode"
              ></DivisionCreate>
              <UserCreate
                v-else-if="viewType === 'userCreate'"
                :division="division"
                @refreshList="selectNode"
              ></UserCreate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-bitwise */
/* eslint-disable no-console */

import Toolbar from '@/components/include/Toolbar';
import Navigation from '@/components/include/Navigation';
import ContentsNavigation from '@/components/include/ContentsNavigation';
import CompanyList from '@/components/account/company/CompanyList';
import CompanyDetail from '@/components/account/company/CompanyDetail';
import CompanyCreate from '@/components/account/company/CompanyCreate';
import DivisionList from '@/components/account/division/DivisionList';
import DivisionDetail from '@/components/account/division/DivisionDetail';
import DivisionCreate from '@/components/account/division/DivisionCreate';
import UserList from '@/components/account/user/UserList';
import UserDetail from '@/components/account/user/UserDetail';
import UserCreate from '@/components/account/user/UserCreate';
import TreeView from '@/components/include/TreeView';

export default {
  components: {
    Toolbar,
    Navigation,
    ContentsNavigation,
    CompanyList,
    CompanyDetail,
    CompanyCreate,
    DivisionList,
    DivisionDetail,
    DivisionCreate,
    UserList,
    UserDetail,
    UserCreate,
    TreeView,
  },
  data: () => ({
    menu: null,
    treeType: 'division',
    treeScope: 'all',
    viewType: 'companyList',
    company: null,
    division: null,
    user: null,
    selectEvent: 0,
    refreshEvent: 0,
    searchCondition: null,
    startTime: '',
    endTime: '',
    menuInfo: {
      mainTitle: 'Account',
      mainName: '계정/권한 관리',
      subTitle: '',
      subName: '',
      company: null,
      division: null,
      user: null,
      device: null,
      tray: null,
      product: null,
    },
  }),
  created() {
    this.menu = this.$route.name;
  },
  methods: {
    selectNode(object, type, isTreeRefresh) {
      if (type === 'all') {
        this.company = null;
        this.division = null;
        this.user = null;
        this.viewType = 'companyList';
        this.selectEvent ^= 1;
        this.menuInfo.company = null;
        this.menuInfo.division = null;
        this.menuInfo.user = null;
      } else if (type === 'company') {
        this.company = object;
        this.division = null;
        this.user = null;
        this.viewType = 'divisionList';
        this.selectEvent ^= 1;
        this.menuInfo.company = object;
        this.menuInfo.division = null;
        this.menuInfo.user = null;
      } else if (type === 'division') {
        this.company = null;
        this.division = object;
        this.user = null;
        this.viewType = 'userList';
        this.selectEvent ^= 1;
        this.menuInfo.company = null;
        this.menuInfo.division = object;
        this.menuInfo.user = null;
      }

      if (isTreeRefresh) {
        this.refreshEvent ^= 1;
      }
    },
    companyDetail(company) {
      this.company = company;
      this.division = null;
      this.user = null;
      this.viewType = 'companyDetail';
      this.selectEvent ^= 1;
      this.menuInfo.company = company;
      this.menuInfo.division = null;
      this.menuInfo.user = null;
    },
    divisionDetail(division) {
      this.company = null;
      this.division = division;
      this.user = null;
      this.viewType = 'divisionDetail';
      this.selectEvent ^= 1;
      this.menuInfo.company = null;
      this.menuInfo.division = division;
      this.menuInfo.user = null;
    },
    userDetail(user, division) {
      this.company = null;
      this.division = division;
      this.user = user;
      this.viewType = 'userDetail';
      this.selectEvent ^= 1;
      this.menuInfo.company = null;
      this.menuInfo.division = null;
      this.menuInfo.user = user;
    },
    companyCreate() {
      this.company = null;
      this.division = null;
      this.user = null;
      this.viewType = 'companyCreate';
      this.menuInfo.company = null;
      this.menuInfo.division = null;
      this.menuInfo.user = null;
    },
    divisionCreate(company) {
      this.company = company;
      this.division = null;
      this.user = null;
      this.viewType = 'divisionCreate';
      this.menuInfo.company = company;
      this.menuInfo.division = null;
      this.menuInfo.user = null;
    },
    userCreate(division) {
      this.company = null;
      this.division = division;
      this.user = null;
      this.viewType = 'userCreate';
      this.menuInfo.company = null;
      this.menuInfo.division = division;
      this.menuInfo.user = null;
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/account/Account.vue